import { useContext } from 'react';
import { BopisDataType, BopisContext } from '@core-ui/bopis';
import useBRVintage from '../features/useBRVintage';

interface UseBopisReturnType {
  enabled: boolean;
  bopisData: BopisDataType;
}

const useBopis = (): UseBopisReturnType => {
  const bopisData = useContext(BopisContext);
  const isBRVintageEnabled = useBRVintage();
  return {
    enabled: bopisData?.enabled && !isBRVintageEnabled,
    bopisData,
  };
};

export default useBopis;
